import { useEffect, useRef } from "react";

/**
 * Calls `handler` when a pointerdown occurs outside the returned ref element.
 * Ignores right-clicks (context menu).
 */
export function useClickOutside<T extends HTMLElement>(
  handler: () => void,
): React.RefObject<T> {
  const ref = useRef<T>(null);
  const handlerRef = useRef(handler);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    const onPointerDown = (event: PointerEvent) => {
      if (event.button === 2) return;
      const el = ref.current;
      if (el && !el.contains(event.target as Node)) {
        handlerRef.current();
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    return () => document.removeEventListener("pointerdown", onPointerDown);
  }, []);

  return ref;
}
